import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';


@NgModule({
	declarations: [],
	imports: [
		CommonModule
	]
})
export class SvgIconsModule {
	constructor(iconReg: MatIconRegistry, sanitizer: DomSanitizer) {
		iconReg.addSvgIcon('globe-glyph', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/globe-glyph.svg'));
		iconReg.addSvgIcon('home-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/home-solid.svg'));
		iconReg.addSvgIcon('lock-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/lock-solid.svg'));
		iconReg.addSvgIcon('material-home', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/material_home.svg'));
		iconReg.addSvgIcon('material-logout', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/material_logout.svg'));
		iconReg.addSvgIcon('person-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/person-solid.svg'));
		iconReg.addSvgIcon('contact', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/contact.svg'));
		iconReg.addSvgIcon('search-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/search-solid.svg'));
		iconReg.addSvgIcon('search-TXT', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/search-TXT.svg'));
		iconReg.addSvgIcon('star-glyph', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/star-glyph.svg'));
		iconReg.addSvgIcon('star-glyph-filled', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/star-glyph-filled.svg'));
		iconReg.addSvgIcon('filler', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/BW_Schweisszusaetze.svg'));
		iconReg.addSvgIcon('material', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/BW_Material.svg'));
		iconReg.addSvgIcon('standard', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/BW_Normen.svg'));
		iconReg.addSvgIcon('not-valid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/notvalid.svg'));
		iconReg.addSvgIcon('valid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/valid.svg'));
		iconReg.addSvgIcon('arrow-solid', sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/arrow-solid.svg'));
		iconReg.registerFontClassAlias('menu', 'voest-icons__menu');
		iconReg.registerFontClassAlias('arrow-right', 'voest-icons__arrow-right');
		iconReg.registerFontClassAlias('arrow-left', 'voest-icons__arrow-left');
		iconReg.registerFontClassAlias('arrow-down', 'voest-icons__arrow-down');
		iconReg.registerFontClassAlias('arrow-up', 'voest-icons__arrow-up');
		iconReg.registerFontClassAlias('search', 'voest-icons__search');
		iconReg.registerFontClassAlias('plus', 'voest-icons__plus');
		iconReg.registerFontClassAlias('minus', 'voest-icons__minus');
		iconReg.registerFontClassAlias('other', 'voest-icons__other');
	}
}
